export interface FileIconInfo {
  icon: string;
  className: string;
}

export const getFileIcon = (filename: string): FileIconInfo => {
  const ext = filename.toLowerCase().split('.').pop();

  if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'].includes(ext || '')) {
    return { icon: 'image', className: 'icon-image' };
  } else if (['xlsx', 'xls', 'csv', 'xlsm', 'xlsb'].includes(ext || '')) {
    return { icon: 'grid_on', className: 'icon-spreadsheet' };
  } else if (['pdf'].includes(ext || '')) {
    return { icon: 'picture_as_pdf', className: 'icon-pdf' };
  } else if (['doc', 'docx', 'txt', 'rtf'].includes(ext || '')) {
    return { icon: 'description', className: 'icon-default' };
  } else {
    return { icon: 'insert_drive_file', className: 'icon-default' };
  }
};
